var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecevie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-": "",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9h8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13h6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21l-1 -1l-2 -2h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19l2 2l4 -4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecevie);
export default __webpack_public_path__ + "static/media/recevie.1548de156933cb48869a62d4e40c16c5.svg";
export { ForwardRef as ReactComponent };